import React, { useState, useEffect, useCallback } from "react";
import HeroBanner from "./HeroBanner";
import Values from "./Value";
import TQservices from "./Services";
import TQsector from "./Sectors";
import TQwhatsNew from "./WhatsNew";
import Global from "../HomePage/Global";
import TQCertificates from "./Certificates";
import TQsustainability from "./Sustainability";
import TQjoinTeam from "./JoinTeam";
import { getBannerAPI, 
    getWhoWeAreAPI, 
    getWhatWeOfferAPI, 
    getOfferTabAPI, 
    getLeadershipAPI, 
    getJoinTeamspAPI, 
    getOfferTabImageAPI, 
    getImprovementAPI,
    getSectorsAPI,
    getKeyProjectsAPI, getWhatsNewAPI, getSustainabilityAPI } from "../../services/routes.services";

import Loader from "../Common/PageLoader/LoadingSpinner";
    

const HomeRoute = ()=>{
    const [weAreData, setWeAreData] = useState([]);
    const [weOffer, setWeOffer] = useState([]);
    const [weOfferTab, setWeOfferTab] = useState([]);
    const [weOfferTabImage, setWeOfferTabImage] = useState([]);
    const [teamData, setTeamData] = useState([]);
    const [improveData, setImproveData] = useState([]);
    const [keyData, setKeyData] = useState([]);
    const [loading, setLoading] = useState(true);

    //new section data 
    const [bannerData, setBannerData] = useState([]);
    const [valueData, setValueData] = useState([]);
    const [servicesData, setServicesData] = useState([]);
    const [sectorData, setSectorData] = useState([]);
    const [whatNewData, setWhatNewData] = useState([]);
    const [sustainabilityData, setSustainabilityData] = useState([]);
    const [joinTeamData, setJoinTeamData] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            const [bannerRes, valueRes, weOfferTabRes, sectorRes, whatsNewRes, sustainabilityRes, joinTeamRes] = await Promise.all([
                getBannerAPI(),
                getWhoWeAreAPI(),
                getOfferTabAPI(),
                getSectorsAPI(),
                getWhatsNewAPI(),
                getSustainabilityAPI(),
                getJoinTeamspAPI(),
            ]);
            setBannerData(bannerRes?.data?.banners);
            setValueData(valueRes?.data?.whoweare[0]?.fields);
            setServicesData(weOfferTabRes?.data?.homeservice);
            setSectorData(sectorRes?.data?.sector);
            setWhatNewData(whatsNewRes?.data?.whatsnew);
            setSustainabilityData(sustainabilityRes?.data?.sustainablity[0]);
            setJoinTeamData(joinTeamRes.data.jointeams[0]);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // const fetchData = useCallback(async () => {
    //     try {
    //         const [bannerRes, weAreRes, weOfferRes, weOfferTabRes, weOfferTabImageRes, teamRes, joinTeamRes, improveRes, sectorRes, keyRes] = await Promise.all([
    //             getBannerAPI(),
    //             getWhoWeAreAPI(),
    //             getWhatWeOfferAPI(),
    //             getOfferTabAPI(),
    //             getOfferTabImageAPI(),
    //             getLeadershipAPI(),
    //             getJoinTeamspAPI(),
    //             getImprovementAPI(),
    //             getSectorsAPI(),
    //             getKeyProjectsAPI()
    //         ]);

    //         setBannerData(bannerRes.data.banners);
    //         setWeAreData(weAreRes.data.whoweare[0]);
    //         setWeOffer(weOfferRes.data.whoweoffermain[0]);
    //         setWeOfferTab(weOfferTabRes.data.homeservice);
    //         setWeOfferTabImage(weOfferTabImageRes.data.homeserviceimage);
    //         setTeamData(teamRes.data.teams);
    //         setJoinTeamData(joinTeamRes.data.jointeams[0]);
    //         setImproveData(improveRes.data.improvments[0]);
    //         setSectorData(sectorRes.data.sector);
    //         setKeyData(keyRes.data.keyproject);

    //     } catch (error) {
    //         console.log(error);
    //     } finally {
    //         setLoading(false);
    //     }
    // }, []);

    // useEffect(() => {
    //     fetchData();
    // }, [fetchData]);

    if (loading) {
        return <Loader />;
    }
    //console.log("12",joinTeamData)
    if (!weAreData || !joinTeamData || !teamData || !weOffer || !weOfferTab) {
        return null;
    }
    //console.log(sustainabilityData)
    return (
        <div>
            <HeroBanner Slider={bannerData} />
            <Values data={valueData} />
            <TQservices data={servicesData} />
            <TQsector data={sectorData} />
            {/* <TQwhatsNew data={whatNewData} /> */}
            <Global />
            <TQCertificates />
            <TQsustainability data={sustainabilityData} />
            <TQjoinTeam data={joinTeamData} />
        </div>
    );
};

export default HomeRoute;
